<template>
  <div class="animated fadeIn">
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <!-- <v-btn elevation="6" outlined small
            ><i class="fa fa-arrow-left text-dark"></i
          ></v-btn>
          تب بعدی <br /> -->
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newItemDialog" max-width="600px">
      <v-card style="overflow-y: scroll" height="80vh">
        <v-card-title style="padding-top: 38px">
          <h4>ثبت جدید</h4>
          <!-- <v-spacer></v-spacer>
          <v-btn
            class="text-white m-1"
            color="red"
            @click="newItemDialog = false"
          >
            لغو
          </v-btn>
          <v-btn color="success m-1" @click="addItem()"> ثبت </v-btn> -->
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <!-- <v-text-field
              outlined
              dense
              label="شرح فارسی *"
              v-model="newItem.identifierFa"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="شرح انگلیسی *"
              dir="ltr"
              v-model="newItem.identifierEn"
            ></v-text-field> -->
            <v-text-field
              outlined
              dense
              label="نام *"
              v-model="newItem.name"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="قیمت (ریال) *"
              :class="newItem.price ? 'rm-bottom' : ''"
              v-model="newItem.price"
            ></v-text-field>
            <p class="px-2" v-if="newItem.price">
              {{ Number(newItem.price).toLocaleString() }} ریال
            </p>
            <v-text-field
              outlined
              dense
              label="تعداد اولیه *"
              v-model="newItem.amount"
            ></v-text-field>
            <p class="px-2" v-if="newItem.amount">
              {{ Number(newItem.amount).toLocaleString() }}
            </p>
            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="newItem.material"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="newItem.coating"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="newItem.dimensionStandard"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="newItem.diameter"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="newItem.length"
            ></v-text-field>

            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="newItem.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="newItemDialog = false">
            لغو
          </v-btn>
          <v-btn
            color="success"
            @click="addItem()"
            :disabled="!newItem.name || !newItem.price || !newItem.amount"
          >
            ثبت
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <b-card>
      <loading v-if="vLoading" />
      <v-card-title>
        <v-row>
          <v-col>
            <h4>انبارداری فروشگاه</h4>
          </v-col>
          <v-col>
            <b-btn @click="openNewItemDialog()" class="btn-dark float-left mx-2"
              >+ ثبت محصول جدید +</b-btn
            >
          </v-col>
        </v-row>
      </v-card-title>
      <b-tabs pills card content-class="mt-3">
        <b-tab title="اقلام موجود در انبار فروشگاه" active>
          <h6>
            <b-input-group size="md">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>
          <b-table
            responsive
            show-empty
            id="productsTable"
            :items="allItems"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="currentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(price)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value.toLocaleString() }} ریال
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <b-button variant="primary" class="ma-2" @click="openEditModal(data.item)"
                  >جزییات
                </b-button>
                <b-button variant="success" class="ma-2 white--text" @click="addEntryDialog(data.item)"
                  >افزایش موجودی
                </b-button>
              </div>
            </template>

            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (currentPage - 1) }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows2"
            :per-page="perPage"
            aria-controls="productsTable"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
          <br />
        </b-tab>
        <b-tab title="رسید و حواله‌های انبار فروشگاه">
          <v-row>
            <v-col cols="5">
              <b-form-group label="از تاریخ">
                <date-picker
                  v-model="exchangeFrom"
                  :editable="true"
                ></date-picker>
              </b-form-group>
            </v-col>
            <v-col cols="5">
              <b-form-group label="تا تاریخ">
                <date-picker
                  v-model="exchangeTo"
                  :editable="true"
                ></date-picker>
              </b-form-group>
            </v-col>
            <v-col cols="2" class="align-middle">
              <b-btn @click="searchExchanges()" class="btn btn-dark mt-7">
                جستجو
              </b-btn>
            </v-col>
          </v-row>
          <b-table
            responsive
            show-empty
            id="detailsTable"
            :items="allExchanges"
            :fields="exchangesFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="exchangeCurrentPage"
            :per-page="exchangePerPage"
            :busy="exchangeIsBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{
                  data.index + 1 + exchangePerPage * (exchangeCurrentPage - 1)
                }}
              </div>
            </template>
            <!-- <template v-slot:cell(operation)="row">
              <b-button
                v-if="row.item._showDetails"
                variant="danger"
                @click="row.toggleDetails"
                >بستن
              </b-button>
              <b-button v-else variant="primary" @click="row.toggleDetails"
                >عملیات
              </b-button>
            </template>

            <template #row-details="row">
              <div
                class="animated fadeIn"
                style="text-align: center; vertical-align: middle"
              >
                <b-button
                  class="mx-1"
                  variant="primary"
                  v-if="row.item.status != 'تایید نهایی'"
                  @click="submitCorrection(row.item, warehouse.warehouseId)"
                  >اصلاح سند
                </b-button>
                <b-button
                  class="mx-1"
                  variant="success"
                  v-if="row.item.status != 'تایید نهایی'"
                  @click="approve(row.item)"
                  >تایید نهایی
                </b-button>
                <b-button
                  class="mx-1"
                  variant="danger"
                  v-if="row.item.status != 'تایید نهایی'"
                  @click="doDelete(row.item)"
                  >حذف تراکنش
                </b-button>
                <b-button
                  class="mx-1"
                  variant="warning"
                  v-if="row.item.status == 'تایید نهایی'"
                  @click="needEdit(row.item)"
                  >نیاز به اصلاح
                </b-button>
              </div>
            </template> -->
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-model="exchangeCurrentPage"
            :total-rows="allExchanges.length"
            :per-page="exchangePerPage"
            aria-controls="detailsTable"
            align="center"
            size="md"
            class="my-0"
          ></b-pagination>
          <br />
        </b-tab>
      </b-tabs>
    </b-card>
    <v-dialog v-model="changeInventoryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>تغییر موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="changeInventory-btn mt-3">
            <v-btn color="success" class="mb-4" @click="openEntryDialog()"
              >ورود کالا - افزایش موجودی</v-btn
            >
            <v-btn color="red" class="text-light mb-4" @click="openExitDialog()"
              >خروج کالا – کاهش موجودی</v-btn
            >
            <v-btn class="text-light mb-4 primary" @click="openTransferDialog()"
              >جابجایی کالا</v-btn
            >
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="entryDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ورود کالا - افزایش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ ورود">
              <date-picker v-model="entry.date" :editable="true"></date-picker>
            </b-form-group>
            <b-form-group label="ساعت ورود">
              <date-picker
                v-model="entry.time"
                :editable="true"
                type="time"
              ></date-picker>
            </b-form-group>
            <v-text-field
              outlined
              dense
              label="حجم ورودی"
              v-model="entry.number"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مبدا"
              v-model="entry.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="entry.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="entryDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="entrySubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="exitDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>خروج کالا - کاهش موجودی</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <b-form-group label="تاریخ خروج">
              <date-picker v-model="exit.date" :editable="true"></date-picker>
            </b-form-group>
            <v-text-field
              outlined
              dense
              label="حجم خروجی"
              v-model="exit.number"
              type="number"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="مقصد"
              v-model="exit.origin"
            ></v-text-field>
            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="exit.description"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="exitDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="exitSubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="transferDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>جابجایی کالا</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-text-field
              outlined
              dense
              disabled
              label="جابجایی از"
              v-model="selected.warehouseSectionName"
            ></v-text-field>
            <v-select
              outlined
              dense
              label="جابجایی به"
              v-model="transfer.to"
              :items="otherWarehouses"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="transferDialog = false">
            لغو
          </v-btn>
          <v-btn color="primary" @click="transferSubmit()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editDialog" max-width="600px">
      <v-card>
        <v-card-title>
          <h4>ویرایش</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <v-row>
              <v-col cols="1" class="pb-0"
                ><v-checkbox
                  class="my-auto mt-1"
                  v-model="check.coating"
                  color="primary"
                  hide-details
                ></v-checkbox
              ></v-col>
              <v-col cols="11" class="pb-0">
                <v-text-field
                  :disabled="check.coating == false"
                  outlined
                  dense
                  label="پوشش"
                  v-model="edit.coating"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="1" class="py-0"
                ><v-checkbox
                  class="my-auto mt-1"
                  v-model="check.diameter"
                  color="primary"
                  hide-details
                ></v-checkbox
              ></v-col>
              <v-col cols="11" class="py-0">
                <v-text-field
                  :disabled="check.diameter == false"
                  outlined
                  dense
                  label="قطر"
                  v-model="edit.diameter"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="1" class="py-0"
                ><v-checkbox
                  class="my-auto mt-1"
                  v-model="check.length"
                  color="primary"
                  hide-details
                ></v-checkbox
              ></v-col>
              <v-col cols="11" class="py-0">
                <v-text-field
                  :disabled="check.length == false"
                  outlined
                  dense
                  label="طول"
                  v-model="edit.length"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="closeEditModal()">
            لغو
          </v-btn>
          <v-btn color="primary" @click="editProduct()"> ثبت </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="detailDialog" max-width="600px">
      <v-card style="overflow-y: scroll" height="80vh">
        <v-card-title>
          <h4>جزییات</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <br />
            <b-table
              responsive
              show-empty
              id="detailsTable"
              :items="info"
              :fields="fields2"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد"
              striped
              :current-page="currentPage"
              :per-page="perPage"
              :busy="isBusy2"
              :filter="filter"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:cell(progress)="data">
                <b-progress
                  :value="data.item.progress"
                  variant="success"
                  :striped="striped"
                  show-progress
                  animated
                ></b-progress>
              </template>

              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <div slot="table-busy" class="text-center text-danger my-2">
                <strong>در حال بارگذاری...</strong>
                <br />
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="info.length"
              :per-page="perPage"
              aria-controls="detailsTable"
              align="center"
              size="md"
              class="my-0"
            ></b-pagination>
            <br />
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="editModal" max-width="600px">
      <v-card style="overflow-y: scroll" height="80vh">
        <v-card-title>
          <h4>جزییات</h4>
        </v-card-title>
        <v-card-text class="py-0 px-2">
          <v-container class="mt-3">
            <!-- <v-text-field
              outlined
              dense
              label="شرح فارسی *"
              :loading="isBusy2"
              v-model="info.identifierFa"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="شرح انگلیسی *"
              dir="ltr"
              :loading="isBusy2"
              v-model="info.identifierEn"
            ></v-text-field> -->
            <v-text-field
              outlined
              dense
              label="نام *"
              :loading="isBusy2"
              v-model="info.name"
            ></v-text-field>
            <v-text-field
              outlined
              dense
              label="قیمت (ریال) *"
              :class="info.price ? 'rm-bottom' : ''"
              v-model="info.price"
              :loading="isBusy2"
            ></v-text-field>
            <p class="px-2" v-if="info.price">
              {{ Number(info.price).toLocaleString() }} ریال
            </p>
            <v-text-field
              outlined
              dense
              label="متریال"
              v-model="info.material"
              :loading="isBusy2"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="پوشش"
              v-model="info.coating"
              :loading="isBusy2"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="استاندارد ابعاد"
              v-model="info.dimensionStandard"
              :loading="isBusy2"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="قطر"
              v-model="info.diameter"
              :loading="isBusy2"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              label="طول"
              v-model="info.length"
              :loading="isBusy2"
            ></v-text-field>

            <v-textarea
              outlined
              dense
              label="توضیحات"
              v-model="info.description"
              :loading="isBusy2"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions class="p-3 mr-3">
          <v-spacer></v-spacer>
          <v-btn class="text-white" color="red" @click="editModal = false">
            لغو
          </v-btn>
          <v-btn
            color="primary"
            @click="editItem()"
            :disabled="!info.name || !info.price"
          >
            ویرایش
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";

import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import Var from "../../../variables"; // NOTE (IMPORT) to transfer variables from a special file of variables

export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    
  },

  data: function () {
    return {
      guide: false,
      // types: Var.allTypes,
      // type: {},
      guide: false,
      allItems: [],
      products: [],
      otherWarehouses: [],
      entry: {},
      entryDialog: false,
      productFilter: "all",
      changeInventoryDialog: false,
      entryDialog: false,
      exitDialog: false,
      transferDialog: false,
      editDialog: false,
      newProductDialog: false,
      detailDialog: false,
      advanceFilter: false,
      adFilter: {},
      info: [],
      selected: "",
      selected2: [],
      entry: {},
      exit: {},
      transfer: {},
      edit: {},
      newProduct: {},
      check: {
        name: false,
        material: false,
        coating: false,
        standard: false,
        diameter: false,
        length: false,
        number: false,
        description: false,
      },
      moment: moment,
      showProgress: false,
      items: [],
      filterOpt: [
        { key: "all", label: "همه" },
        { key: "exist", label: "اقلام دارای موجودی" },
        { key: "none", label: "اقلام بدون موجودی" },
      ],
      filter: null,
      fields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "sum", label: "موجودی" },
        { key: "operation", label: "عملیات" },
      ],
      fields2: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "amount", label: "مقدار" },
        { key: "date", label: "تاریخ" },
      ],
      currentPage: 1,
      perPage: 10,
      isBusy: false,
      isBusy2: false,
      TotalRows: 1,
      totalRows2: 1,
      exchangeFrom: "",
      exchangeTo: "",
      selectedItem: {},
      allExchanges: [],
      exchangesFields: [
        { key: "index", label: "ردیف" },
        { key: "type", label: "نوع" },
        { key: "warehouseItemName", label: "کالا" },
        { key: "amount", label: "مقدار" },
        // { key: "status", label: "وضعیت" },
        // { key: "note", label: "توضیحات" },
        // { key: "orgDes", label: "مبدا / مقصد" },
        { key: "userName", label: "کاربر" },
        { key: "date", label: "تاریخ" },
        { key: "note", label: "توضیحات" },

        // { key: "operation", label: "عملیات" }
      ],
      exchangeCurrentPage: 1,
      exchangePerPage: 10,
      exchangeIsBusy: false,
      newItemDialog: false,
      newItem: {},
      type: Var.allTypes[3],
      editModal: false,
      info: {},
    };
  },

  methods: {
    toggleHelp() {
      this.guide = !this.guide;
    },
    openEditModal(item) {
      (this.info = {}), (this.selected = item);
      this.editModal = true;
      this.getInfo();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows2 = filteredItems.length;
      this.currentPage = 1;
    },
    addEntryDialog(item) {
      this.selectedItem = item;
      this.entry = {};
      this.entryDialog = true;
    },
    entrySubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/exchanges/entrance",
        {
          warehouseItemId: this.selectedItem.id,
          warehouseId: "6174364e034d1b5b3b880f6b",
          amount: this.entry.number,
          date: this.entry.date + " " + this.entry.time,
          orgDes: this.entry.origin,
          note: this.entry.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.entryDialog = false;
            this.entry = {};
            this.getProducts();
            this.searchExchanges();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    addItem() {
      Axios.post(
        this.baseUrl + "/ppkpms/shop/goods/new",
        {
          warehouseTypeId: this.type.id,
          name: this.newItem.name,
          amount: this.newItem.amount,
          identifierFa: this.newItem.name,
          identifierEn: this.newItem.name,
          description: this.newItem.description,
          technicalDescription: this.newItem.technicalDescription,
          material: this.newItem.material,
          coating: this.newItem.coating,
          dimensionStandard: this.newItem.dimensionStandard,
          diameter: this.newItem.diameter,
          length: this.newItem.length,
          place: this.newItem.place,
          suppliersList: this.newItem.suppliersList,
          expireDate: this.newItem.expireDate,
          measurementUnit: this.newItem.measurementUnit,
          alertRange: this.newItem.alertRange,
          crisisRange: this.newItem.crisisRange,
          price: this.newItem.price,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.newItemDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    editItem() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/edit",
        {
          warehouseItemId: this.selected.id,
          name: this.info.name,
          identifierFa: this.info.name,
          identifierEn: this.info.name,
          description: this.info.description,
          technicalDescription: this.info.technicalDescription,
          material: this.info.material,
          coating: this.info.coating,
          dimensionStandard: this.info.dimensionStandard,
          diameter: this.info.diameter,
          length: this.info.length,
          place: this.info.place,
          suppliersList: this.info.suppliersList,
          expireDate: this.info.expireDate,
          measurementUnit: this.info.measurementUnit,
          alertRange: this.info.alertRange,
          crisisRange: this.info.crisisRange,
          price: this.info.price,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editModal = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    searchExchanges() {
      this.exchangeIsBusy = true;
      let startDate = this.exchangeFrom + " 00:00";
      let finishDate = this.exchangeTo + " 23:59";
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouse/exchanges",
        {
          warehouseId: "6174364e034d1b5b3b880f6b",
          startDate: startDate,
          finishDate: finishDate,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.allExchanges = res.data;
            this.exchangeIsBusy = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },

    toggleHelp() {
      this.guide = !this.guide;
    },
    openChangeInventoryDialog(product) {
      this.changeInventoryDialog = true;
      this.selected = product;
    },
    openEntryDialog() {
      this.entryDialog = true;
      this.entry.date = "";
      this.entry.number = "";
      (this.entry.origin = ""), (this.entry.description = "");
    },
    openExitDialog() {
      this.exitDialog = true;
      this.exit.date = "";
      this.exit.number = "";
      (this.exit.origin = ""), (this.exit.description = "");
    },
    openTransferDialog() {
      this.transferDialog = true;
      this.transfer.to = "";
    },
    openEditDialog(product) {
      this.editDialog = true;
      this.selected2 = product;
      this.edit.name = product.name;
      this.edit.material = product.material;
      this.edit.coating = product.coating;
      this.edit.dimensionStandard = product.dimensionStandard;
      this.edit.diameter = product.diameter;
      this.edit.length = product.length;
      this.edit.number = product.number;
      this.edit.description = product.description;
    },
    closeEditModal() {
      this.editDialog = false;
      this.check.name = false;
      this.check.material = false;
      this.check.coating = false;
      this.check.standard = false;
      this.check.diameter = false;
      this.check.length = false;
      this.check.number = false;
      this.check.description = false;
    },
    openDetailDialog(product) {
      this.detailDialog = true;
      this.selected = product.id;
      this.getInfo();
    },
    openNewItemDialog() {
      this.newItemDialog = true;
      this.newItem = {};
    },
    openAdvanceFilter() {
      this.advanceFilter = true;
      this.selected = "6174364e034d1b5b3b880f6b";
    },
    advanecFilter() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItems/filter",
        {
          warehouseSectionId: "6174364e034d1b5b3b880f6b",
          description: this.adFilter.description,
          material: this.adFilter.material,
          coating: this.adFilter.coating,
          dimensionStandard: this.adFilter.dimensionStandard,
          diameter: this.adFilter.diameter,
          length: this.adFilter.length,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.products = res.data;
            this.advanceFilter = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    delFilter() {
      this.adFilter.description = "";
      this.adFilter.material = "";
      this.adFilter.coating = "";
      this.adFilter.dimensionStandard = "";
      this.adFilter.diameter = "";
      this.adFilter.length = "";
      this.getProducts();
      this.advanceFilter = false;
    },
    getInfo() {
      this.isBusy2 = true;
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/getInfo",
        {
          warehouseItemId: this.selected.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy2 = false;
          if (res.status == 200) {
            this.info = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy2 = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    exitSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/exit",
        {
          warehouseItemId: this.selected.id,
          amount: this.exit.number,
          date: this.exit.date,
          orgDes: this.exit.origin,
          note: this.exit.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data, "success");
            this.exitDialog = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    transferSubmit() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/transfer",
        {
          warehouseItemId: this.selected.id,
          warehouseSectionId: this.transfer.to,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.transferDialog = false;
            this.changeInventoryDialog = false;
            this.getProducts();
            this.searchExchanges();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    editProduct() {
      Axios.post(
        this.baseUrl + "/ppkpms/warehouse/warehouseItem/convert",
        {
          warehouseItemId: this.selected2.id,
          coating: this.edit.coating,
          diameter: this.edit.diameter,
          length: this.edit.length,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.editDialog = false;
            this.check.name = false;
            this.check.material = false;
            this.check.coating = false;
            this.check.standard = false;
            this.check.diameter = false;
            this.check.length = false;
            this.check.number = false;
            this.check.description = false;
            this.getProducts();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
        });
    },
    getProducts() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/goods/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.allItems = res.data;
            this.totalRows2 = this.allItems.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.isBusy = false;
          this.toast("خطا: " + err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getProducts();
    this.exchangeTo = moment(new Date()).format("jYYYY/jMM/jDD");
    this.exchangeFrom = moment(new Date())
      .subtract(7, "d")
      .format("jYYYY/jMM/jDD");
    this.searchExchanges();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
.nav-pills {
  padding: 10px !important;
}
.changeInventory-btn {
  display: flex;
  align-items: center;
  flex-flow: column;
}
.rm-bottom {
  .v-text-field__details {
    display: none !important;
  }
}
</style>
